import { render } from "./Header.vue?vue&type=template&id=594df7d9&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=594df7d9&lang=scss&scoped=true"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594df7d9"]])

export default __exports__